import { render, staticRenderFns } from "./ImportClientsWithFieldSelect.vue?vue&type=template&id=bc541066"
import script from "./ImportClientsWithFieldSelect.vue?vue&type=script&lang=js"
export * from "./ImportClientsWithFieldSelect.vue?vue&type=script&lang=js"
import style0 from "./ImportClientsWithFieldSelect.vue?vue&type=style&index=0&id=bc541066&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports